/**
 * スティッキーバーの「カートに追加する」ボタン（StickyAddToCart）を、
 * メイン商品フォームのIOバリデーション（sp-validate-overlay）と連動させるスクリプト
 *
 * 前提：スティッキーボタンは form="メインフォームのID" 属性で
 * メインフォームに直接紐付いている（フォームは1つだけ共有）ケース用。
 *
 * 導入方法：
 * 1. このファイルを assets/ フォルダにアップロード
 *    （例: assets/sticky-atc-io-validate-sync.js）
 * 2. theme.liquid の </body> 直前などで読み込む
 *      <script src="{{ 'sticky-atc-io-validate-sync.js' | asset_url }}" defer="defer"></script>
 */
document.addEventListener('DOMContentLoaded', function () {
  var stickyButton = document.getElementById('StickyAddToCart');
  if (!stickyButton) return;

  stickyButton.addEventListener('click', function (e) {
    // メインボタンに乗っているIOのバリデーション用オーバーレイを探す
    var mainOverlay = document.querySelector('.sp-validate-overlay');

    // オーバーレイが見つからない場合は、IOが未ロード or 対象外なので通常通りにする
    if (!mainOverlay) return;

    // スティッキーボタンからのクリック（＝フォーム送信）を止める
    // ※ form属性で紐付いたボタンは、clickをpreventDefaultすると
    //    紐付いたフォームのsubmitも同時にキャンセルされる
    e.preventDefault();

    // フォームは1つを共有しているので、値の同期は不要。
    // IOのオーバーレイをクリックさせ、必須項目チェックを発動させるだけでよい。
    mainOverlay.click();
  });
});